import { Switchboard } from "../events";
import { Maybe } from "../misc/option";
import { ForgetfulStack } from "../misc/structures";
const CTX_STACK_DEPTH = 3;
export class ContextManager {
    constructor() {
        this.contexts = [];
        this.context_stack = new ForgetfulStack(CTX_STACK_DEPTH);
        this.emitter = Switchboard.get_emitter("CONTEXT");
        this.receiver = Switchboard.get_receiver("CONTEXT");
        this.receiver.on('ctx_request', (requested) => {
            if (requested === '')
                return;
            if (requested === 'revert')
                return this.revert();
            if (requested === 'set-group') {
                if (this.context.isSomeAnd(c => c.name === 'group'))
                    return;
                this.update_context('set');
                return;
            }
            this.update_context(requested);
        });
        this.receiver.on('revert', (_b) => {
            this.revert();
        });
        this.receiver.on('req_or_revert', (ctx_name) => {
            this.context.mapOr(this.update_context(ctx_name), c => c.name === ctx_name ? this.revert() : this.update_context(ctx_name));
        });
        this.receiver.on('zoom', (force) => {
            this.context.map(c => c.zoom(force));
        });
    }
    get context() {
        return this.context_stack.current();
    }
    get context_name() {
        return this.context.map(a => a.name);
    }
    get context_names() {
        return this.contexts.map(c => c.name);
    }
    add_contexts(...contexts) {
        this.contexts.push(...contexts);
    }
    update_context(name) {
        const ctx_exists = this.context_names.includes(name);
        const same_context = this.context.map(c => c.name === name).unwrapOr(false);
        const ctx_can_be_switched_to = this.context.map(c => c.exit_contexts.includes(name)).unwrapOr(true);
        if (!ctx_exists || same_context || !ctx_can_be_switched_to) {
            this.broadcast();
            return;
        }
        this.context.map(c => c.on_exit());
        this.get_context(name)
            .map(ctx => { this.context_stack.push(ctx); return ctx; })
            .map(ctx => ctx.on_enter());
        this.broadcast();
    }
    revert() {
        this.context.map(c => c.on_exit());
        this.context_stack.pop();
        this.context.map(c => c.on_enter());
        this.broadcast();
    }
    get_context(name) {
        return Maybe(this.contexts.find(c => c.name === name));
    }
    broadcast() {
        this.context.map(ctx => this.emitter.emit('ctx_change', ctx));
    }
}
